import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // 데이터가 5분간 fresh 상태로 유지
      staleTime: 1000 * 60 * 5,
      // 백그라운드에서 10분간 캐시 유지
      gcTime: 1000 * 60 * 10,
      // 에러 발생 시 재시도 횟수
      retry: (failureCount, error: any) => {
        if (
          error?.response?.status === 401 ||
          error?.response?.status === 403 ||
          error?.response?.status === 404
        ) {
          return false;
        }
        return failureCount < 3;
      },
      // 재시도 간격
      retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
      // 브라우저 포커스 시 refetch 비활성화
      refetchOnWindowFocus: false,
      // 네트워크 재연결 시 refetch
      refetchOnReconnect: 'always',
    },
    mutations: {
      retry: false,
    },
  },
});
